
/**
 * [deliveries description]
 * @return {[type]} [description]
 */
var deliveries = function()
{



	/**
	 * [postcodes description]
	 * @return {[type]} [description]
	 */
	this.postcodes = function()
	{

		/**
		 * [addToPostcodesList description]
		 * @param {[type]} model      [description]
		 * @param {[type]} attributes [description]
		 * @param {[type]} modal      [description]
		 */
		var addToPostcodesList = function( model, attributes, modal )
		{

            modal.semanticUiModal( 'hide' );
			var tbody = $( '[data-for="postcodes-list"]' );
			var noPostcodes = $( '[data-for="no-postcodes"]' );
			var row = $( '<tr />' ).attr( 'data-row-id', model.id );
			var buttonCol = $('<td />');
			var buttons = $('<div class="btn-group" />');
			var deleteButton = $('<a data-for="delete-postcode" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>')
				.attr('data-row-id', model.id)
				.attr('href', model.delete_url);

			row.append( $( '<td />' ).text( model.id ) );
			row.append( $( '<td />' ).text( model.code ) );
			row.append( $( '<td />' ).text( '' ) );

			deleteButton.appendTo( buttons );
			buttons.appendTo( buttonCol );
			buttonCol.appendTo( row );

			noPostcodes.remove();
			row.appendTo( tbody );
			bindEvents();

		};

		/**
		 * [removeFromPostcodesList description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var removeFromPostcodesList = function( model, attributes, modal )
		{
			var tbody = $( '[data-for="postcodes-list"]' );
			var row = $( '[data-row-id="' + model.id + '"]', tbody );
			row.fadeOut( 200, function(){
				$(this).remove();
				if( ! $( 'tr', tbody ).length ) {
					tbody.append( $( '<tr data-for="no-postcodes"><td colspan="4">You currently have no postcodes created</td></tr>' ) );
				}
			});
		};



		/**
		 * [createPostcodeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createPostcodeHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ){
					addToPostcodesList( model, attributes, modal );
				}
			});
		};

		/**
		 * [deletePostcodeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deletePostcodeHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : function( model, attributes, modal ){
					removeFromPostcodesList( model, attributes, modal );
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$( '[data-for="create-postcode"]' ).unbind( 'click' ).bind( 'click', createPostcodeHandler );
			$( '[data-for="delete-postcode"]' ).unbind( 'click' ).bind( 'click', deletePostcodeHandler );
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{
			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			};
		}
	};

	/**
	 * [sites description]
	 * @return {[type]} [description]
	 */
	this.sites = function()
	{

		var xhr;

		/**
		 * [addSiteToList description]
		 * @param {[type]} e [description]
		 */
		var addSiteToList = function(elm)
		{
			var model = elm.data( 'site' );
			var tbody = $('[data-for="sites-list"]');

			$('[data-for="no-sites"]', tbody).remove();

			var row = $('<tr />').attr( 'data-site-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.name ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-site" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#search-sites').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			});
		};

		/**
		 * [siteSearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var siteSearchHandler = function(e)
		{
			var route = $('#search-sites-route').val();
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( sites ){

				var searchContainer = $('<div />').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! sites.length ) {
					var item = $( '<li />' ).text( 'No results found or the site is already attached.' );
					item.appendTo( list );
				}

				sites.forEach(function(site){
					var item = $( '<li />' ).addClass( 'ui blue label' ).attr( 'data-site-id', site.id );
					item.data( 'site', site );
					item.text( site.name );
					item.appendTo( list );
					item.click( function(){
						addSiteToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).removeClass('blue').addClass('green');
					})
					.mouseleave(function(){
						$(this).removeClass('green').addClass('blue');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#search-sites');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		};

		/**
		 * [removeSiteHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeSiteHandler = function(e)
		{
			e.preventDefault();
			$.get( this.href, function( model ){
				$('[data-site-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="sites-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-sites');
						$('<td />').attr('colspan', 4).text('No sites currently attached to this delivery').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
		};

		/**
		 * [removeSearchContainer description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeSearchContainer = function(e)
		{
			if( ! $(e.target).parents('#search-results:eq(0)').length ) {
				$('#search-results', $('body')).remove();
			}
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$( '#search-sites' ).unbind( 'keyup focus' ).bind( 'keyup focus', siteSearchHandler );
			$('[data-for="remove-site"]').unbind('click').bind('click', removeSiteHandler );
			// $(document).unbind('click').bind('click', removeSearchContainer );
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			};
		};
	};

	/**
	 * [deliveryPostcodes description]
	 * @return {[type]} [description]
	 */
	this.deliveryPostcodes = function()
	{

		var xhr;

		/**
		 * [removeDeliveryPostcodeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeDeliveryPostcodeHandler = function(e)
		{
			e.preventDefault();
			$.get( this.href, function( model ){
				$('[data-postcode-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="postcodes-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-postcodes');
						$('<td />').attr('colspan', 4).text('No postcodes currently attached to this delivery.').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
		};

		/**
		 * [addPostcodeToList description]
		 * @param {[type]} elm [description]
		 */
		var addPostcodeToList = function( elm )
		{
			var model = elm.data( 'postcode' );
			var tbody = $('[data-for="postcodes-list"]');

			$('[data-for="no-postcodes"]', tbody).remove();

			var row = $('<tr />').attr( 'data-postcode-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.code ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-site" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#search-postcodes').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			});
		};

		/**
		 * [deliveryPostcodeSearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deliveryPostcodeSearchHandler = function(e)
		{
			var route = $('#search-postcodes-route').val();
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( postcodes ){

				var searchContainer = $('<div />').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! postcodes.length ) {
					var item = $( '<li />' ).text( 'No results found or the postcode is already attached.' );
					item.appendTo( list );
				}

				postcodes.forEach(function(postcode){
					var item = $( '<li />' ).addClass( 'ui blue label' ).attr( 'data-postcode-id', postcode.id );
					item.data( 'postcode', postcode );
					item.text( postcode.code );
					item.appendTo( list );
					item.click( function(){
						addPostcodeToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).removeClass('blue').addClass('green');
					})
					.mouseleave(function(){
						$(this).removeClass('green').addClass('blue');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#search-postcodes');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		};


		/**
		 * [removeSearchContainer description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeSearchContainer = function(e)
		{
			if( ! $(e.target).parents('#search-results:eq(0)').length ) {
				$('#search-results', $('body')).remove();
			}
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$( '#search-postcodes' ).unbind( 'keyup focus' ).bind( 'keyup focus', deliveryPostcodeSearchHandler );
			$('[data-for="remove-postcode"]').unbind('click').bind('click', removeDeliveryPostcodeHandler );
			// $(document).unbind('click').bind('click', removeSearchContainer );
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			};
		};

	};

	/**
	 * [prices description]
	 * @return {[type]} [description]
	 */
	this.prices = function()
	{

		/**
		 * [addToPricesList description]
		 * @param {[type]} model [description]
		 */
		var addToPricesList = function( model, attributes, modal )
		{

			$('[data-javascript="delivery-prices"] [data-for="no-prices"]').remove();

			var row = $('<tr />').attr( 'data-row-id', model.id );
			row.append( $('<td />').text( model.id ) );
			row.append( $('<td />').attr( 'data-for', ( model.price_limit ? 'price-limit' : 'weight-limit' ) ).text( ( model.price_limit ? model.price_limit : model.weight_limit ) ) );
			row.append( $('<td />').attr( 'data-for', 'value' ).text( model.value ) );

			var buttonCol = $('<td />');
			var buttons = $('<div class="btn-group" />');

			var editButton = $('<a data-for="edit-price" class="btn btn-default btn-sm"><i class="fa fa-pencil-square-o"></i></a>')
				.attr('data-for-row-id', model.id )
				.attr('href', model.edit_url );
			var deleteButton = $('<a data-for="remove-price" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></a>')
				.attr('data-row-id', model.id )
				.attr('href', model.delete_url );

			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo( $('[data-for="prices-list"]') );
			bindEvents();
            modal.semanticUiModal( 'hide' );

		};

		/**
		 * [alertPricesList description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var alertPricesList = function( model, attributes, modal )
		{
			var row = $('[data-javascript="delivery-prices"] [data-row-id="' + model.id + '"]');
			$( '[data-for="price-limit"]', row ).text( model.price_limit );
			$( '[data-for="weight-limit"]', row ).text( model.weight_limit );
			$( '[data-for="value"]', row ).text( model.value );
			modal.modal('hide');
		};

		/**
		 * [editPriceHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editPriceHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ){
					alertPricesList( model, attributes, modal );
				}
			});
		};

		/**
		 * [removePriceHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removePriceHandler = function(e)
		{
			e.preventDefault();
			var container = $('[data-javascript="delivery-prices"]');
			$.get( this.href, function( model ){
				$('[data-row-id="' + model.id + '"]', container).fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="prices-list"]', container);
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-prices');
						$('<td />').attr('colspan', 4).text('No prices currently attached to this delivery.').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
		};

		/**
		 * [addPriceHendler description]
		 * @param {[type]} e [description]
		 */
		var addPriceHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ){
					addToPricesList( model, attributes, modal );
				}
			});
		};

		/**
		 * [orderPrices description]
		 * @return {[type]} [description]
		 */
		var orderPrices = function()
		{
			$('[data-javascript="delivery-prices"] table').rowSorter({
				onDrop: function( tbody, row, new_index, old_index ) {
			        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
			        var ids = [];
			        $('tbody tr', table).each(function(){
			        	ids.push( $(this).attr('data-row-id') );
			        });
			        $.ajaxSetup({
			            headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
			        });
			        $.post( $('#order-prices-route').val(), { orders : ids } );
			    },
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{

			$('[data-for="add-price"]').unbind('click').click( addPriceHandler );
			$('[data-for="remove-price"]').unbind('click').click( removePriceHandler );
			$('[data-for="edit-price"]').unbind('click').click( editPriceHandler );
		}

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			this.init = function()
			{
				bindEvents();
				orderPrices();
			}
		}
	};

};

jQuery(document).ready( function($){

	try {

		var deliveriesApp = new deliveries();

		if( $('[data-javascript="delivery-postcodes"]').length ) {
			var deliveryPostcodes = deliveriesApp.deliveryPostcodes();
			deliveryPostcodes.init();
		}

		if( $('[data-javascript="delivery-prices"]').length ) {
			var prices = deliveriesApp.prices();
			prices.init();
		}

		if( $('[data-javascript="delivery-sites"]').length ) {
			var sites = deliveriesApp.sites();
			sites.init();
		}

		if( $('[data-javasscript="postcodes"]').length ) {
			var postcodes = deliveriesApp.postcodes();
			postcodes.init();
		}

	}
	catch( err ) {
		console.log( 'Deliveries: ' + err );
	}

});
